import Layout from "../components/Layout";

function Lexikon() {
  return (
    <Layout>
      <h1>Lexikon</h1>
    </Layout>
  );
}

export default Lexikon;